import React, { useEffect, useState } from 'react';
import './Employee.css'; // Import your CSS file for styling
import { useNavigate } from 'react-router-dom';

export default function Employee() {
  const [isloading, setisloading] = useState(false)
  const [emp, setEmp] = useState([]);
const nav = useNavigate()
  useEffect(() => {
    fetchAllEmployees();
  }, []);

  async function fetchAllEmployees() {
    setisloading(true)
    const res = await fetch("https://payrole.onrender.com/Fetallemployees", {
      method: 'POST',
      body: JSON.stringify(),
      headers: { 'Content-Type': 'application/json' }
    });

    const likedpostcreatedtime = await res.json();
    setEmp(likedpostcreatedtime);
    setisloading(false)
  }

  return (
    <div className="employee-container">

      {isloading?<> 
      

      <h1>Fetching detail.............</h1>

      <div class="spinner-grow" id='spi' role="status">
  <span class="sr-only">Loading...</span>
</div>
      
      </>:<>
      
      <h2>Employee List</h2>
      <div className="employee-list">
        {emp.map((e) => (
          <div key={e.EmployeeID} className="employee-box"   onClick={()=>{


            
            nav(`/payroll/${e.EmployeeID}`)
            
            
            
            
                          }}    >
            <h3>{e.FirstName} {e.LastName}</h3>
            <p>Employee ID: {e.EmployeeID}</p>
            <p>Department ID: {e.DepartmentID}</p>
            <p>Salary: {e.Salary}</p>
          </div>
        ))}
      </div>
      
      
      
      </>}

    </div>
  );
}
